// extracted by mini-css-extract-plugin
export default {"appComponent":"styles_appComponent__FM+y-"};